import { Injectable, inject } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { ToastrService } from './toastr.service';

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {
    private readonly clipboard = inject(Clipboard);
    private readonly toastrService = inject(ToastrService);

    /**
     * Copies the provided text to the clipboard and shows a success toast.
     * 
     * @param text The string to be copied.
     * @param label Optional label for the toast message (e.g., 'Address').
     */
    copy(text: string, label: string = 'Text'): void {
        if (!text) return;

        const pending = this.clipboard.beginCopy(text);
        let remainingAttempts = 3;
        const attempt = () => {
            const result = pending.copy();
            if (!result && --remainingAttempts) {
                setTimeout(attempt);
            } else {
                pending.destroy();
                if (result) {
                    this.toastrService.showToast(`${label} copied to clipboard!`, 'success');
                } else {
                    this.toastrService.showToast(`Failed to copy ${label.toLowerCase()}.`, 'error');
                }
            }
        };
        attempt();
    }
}
